import { b as I, c as S, d as w, e as _, f as tr, a as M, g as E, _ as nr, h as or } from "./tslib-1406810b.js";
function s(r) {
  return typeof r == "function";
}
function ir(r) {
  var e = function(n) {
    Error.call(n), n.stack = new Error().stack;
  }, t = r(e);
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t;
}
var A = ir(function(r) {
  return function(t) {
    r(this), this.message = t ? t.length + ` errors occurred during unsubscription:
` + t.map(function(n, o) {
      return o + 1 + ") " + n.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = t;
  };
});
function F(r, e) {
  if (r) {
    var t = r.indexOf(e);
    0 <= t && r.splice(t, 1);
  }
}
var U = function() {
  function r(e) {
    this.initialTeardown = e, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return r.prototype.unsubscribe = function() {
    var e, t, n, o, i;
    if (!this.closed) {
      this.closed = !0;
      var u = this._parentage;
      if (u)
        if (this._parentage = null, Array.isArray(u))
          try {
            for (var a = I(u), c = a.next(); !c.done; c = a.next()) {
              var h = c.value;
              h.remove(this);
            }
          } catch (f) {
            e = { error: f };
          } finally {
            try {
              c && !c.done && (t = a.return) && t.call(a);
            } finally {
              if (e)
                throw e.error;
            }
          }
        else
          u.remove(this);
      var v = this.initialTeardown;
      if (s(v))
        try {
          v();
        } catch (f) {
          i = f instanceof A ? f.errors : [f];
        }
      var L = this._finalizers;
      if (L) {
        this._finalizers = null;
        try {
          for (var b = I(L), p = b.next(); !p.done; p = b.next()) {
            var er = p.value;
            try {
              Y(er);
            } catch (f) {
              i = i ?? [], f instanceof A ? i = S(S([], w(i)), w(f.errors)) : i.push(f);
            }
          }
        } catch (f) {
          n = { error: f };
        } finally {
          try {
            p && !p.done && (o = b.return) && o.call(b);
          } finally {
            if (n)
              throw n.error;
          }
        }
      }
      if (i)
        throw new A(i);
    }
  }, r.prototype.add = function(e) {
    var t;
    if (e && e !== this)
      if (this.closed)
        Y(e);
      else {
        if (e instanceof r) {
          if (e.closed || e._hasParent(this))
            return;
          e._addParent(this);
        }
        (this._finalizers = (t = this._finalizers) !== null && t !== void 0 ? t : []).push(e);
      }
  }, r.prototype._hasParent = function(e) {
    var t = this._parentage;
    return t === e || Array.isArray(t) && t.includes(e);
  }, r.prototype._addParent = function(e) {
    var t = this._parentage;
    this._parentage = Array.isArray(t) ? (t.push(e), t) : t ? [t, e] : e;
  }, r.prototype._removeParent = function(e) {
    var t = this._parentage;
    t === e ? this._parentage = null : Array.isArray(t) && F(t, e);
  }, r.prototype.remove = function(e) {
    var t = this._finalizers;
    t && F(t, e), e instanceof r && e._removeParent(this);
  }, r.EMPTY = function() {
    var e = new r();
    return e.closed = !0, e;
  }(), r;
}();
U.EMPTY;
function H(r) {
  return r instanceof U || r && "closed" in r && s(r.remove) && s(r.add) && s(r.unsubscribe);
}
function Y(r) {
  s(r) ? r() : r.unsubscribe();
}
var V = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, T = {
  setTimeout: function(r, e) {
    for (var t = [], n = 2; n < arguments.length; n++)
      t[n - 2] = arguments[n];
    var o = T.delegate;
    return o != null && o.setTimeout ? o.setTimeout.apply(o, S([r, e], w(t))) : setTimeout.apply(void 0, S([r, e], w(t)));
  },
  clearTimeout: function(r) {
    var e = T.delegate;
    return ((e == null ? void 0 : e.clearTimeout) || clearTimeout)(r);
  },
  delegate: void 0
};
function j(r) {
  T.setTimeout(function() {
    throw r;
  });
}
function D() {
}
function ur(r) {
  r();
}
var k = function(r) {
  _(e, r);
  function e(t) {
    var n = r.call(this) || this;
    return n.isStopped = !1, t ? (n.destination = t, H(t) && t.add(n)) : n.destination = fr, n;
  }
  return e.create = function(t, n, o) {
    return new O(t, n, o);
  }, e.prototype.next = function(t) {
    this.isStopped || this._next(t);
  }, e.prototype.error = function(t) {
    this.isStopped || (this.isStopped = !0, this._error(t));
  }, e.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, r.prototype.unsubscribe.call(this), this.destination = null);
  }, e.prototype._next = function(t) {
    this.destination.next(t);
  }, e.prototype._error = function(t) {
    try {
      this.destination.error(t);
    } finally {
      this.unsubscribe();
    }
  }, e.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, e;
}(U), cr = Function.prototype.bind;
function P(r, e) {
  return cr.call(r, e);
}
var ar = function() {
  function r(e) {
    this.partialObserver = e;
  }
  return r.prototype.next = function(e) {
    var t = this.partialObserver;
    if (t.next)
      try {
        t.next(e);
      } catch (n) {
        m(n);
      }
  }, r.prototype.error = function(e) {
    var t = this.partialObserver;
    if (t.error)
      try {
        t.error(e);
      } catch (n) {
        m(n);
      }
    else
      m(e);
  }, r.prototype.complete = function() {
    var e = this.partialObserver;
    if (e.complete)
      try {
        e.complete();
      } catch (t) {
        m(t);
      }
  }, r;
}(), O = function(r) {
  _(e, r);
  function e(t, n, o) {
    var i = r.call(this) || this, u;
    if (s(t) || !t)
      u = {
        next: t ?? void 0,
        error: n ?? void 0,
        complete: o ?? void 0
      };
    else {
      var a;
      i && V.useDeprecatedNextContext ? (a = Object.create(t), a.unsubscribe = function() {
        return i.unsubscribe();
      }, u = {
        next: t.next && P(t.next, a),
        error: t.error && P(t.error, a),
        complete: t.complete && P(t.complete, a)
      }) : u = t;
    }
    return i.destination = new ar(u), i;
  }
  return e;
}(k);
function m(r) {
  j(r);
}
function sr(r) {
  throw r;
}
var fr = {
  closed: !0,
  next: D,
  error: sr,
  complete: D
}, R = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function lr(r) {
  return r;
}
function hr(r) {
  return r.length === 0 ? lr : r.length === 1 ? r[0] : function(t) {
    return r.reduce(function(n, o) {
      return o(n);
    }, t);
  };
}
var l = function() {
  function r(e) {
    e && (this._subscribe = e);
  }
  return r.prototype.lift = function(e) {
    var t = new r();
    return t.source = this, t.operator = e, t;
  }, r.prototype.subscribe = function(e, t, n) {
    var o = this, i = vr(e) ? e : new O(e, t, n);
    return ur(function() {
      var u = o, a = u.operator, c = u.source;
      i.add(a ? a.call(i, c) : c ? o._subscribe(i) : o._trySubscribe(i));
    }), i;
  }, r.prototype._trySubscribe = function(e) {
    try {
      return this._subscribe(e);
    } catch (t) {
      e.error(t);
    }
  }, r.prototype.forEach = function(e, t) {
    var n = this;
    return t = G(t), new t(function(o, i) {
      var u = new O({
        next: function(a) {
          try {
            e(a);
          } catch (c) {
            i(c), u.unsubscribe();
          }
        },
        error: i,
        complete: o
      });
      n.subscribe(u);
    });
  }, r.prototype._subscribe = function(e) {
    var t;
    return (t = this.source) === null || t === void 0 ? void 0 : t.subscribe(e);
  }, r.prototype[R] = function() {
    return this;
  }, r.prototype.pipe = function() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    return hr(e)(this);
  }, r.prototype.toPromise = function(e) {
    var t = this;
    return e = G(e), new e(function(n, o) {
      var i;
      t.subscribe(function(u) {
        return i = u;
      }, function(u) {
        return o(u);
      }, function() {
        return n(i);
      });
    });
  }, r.create = function(e) {
    return new r(e);
  }, r;
}();
function G(r) {
  var e;
  return (e = r ?? V.Promise) !== null && e !== void 0 ? e : Promise;
}
function dr(r) {
  return r && s(r.next) && s(r.error) && s(r.complete);
}
function vr(r) {
  return r && r instanceof k || dr(r) && H(r);
}
function pr(r) {
  return s(r == null ? void 0 : r.lift);
}
function y(r) {
  return function(e) {
    if (pr(e))
      return e.lift(function(t) {
        try {
          return r(t, this);
        } catch (n) {
          this.error(n);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function g(r, e, t, n, o) {
  return new yr(r, e, t, n, o);
}
var yr = function(r) {
  _(e, r);
  function e(t, n, o, i, u, a) {
    var c = r.call(this, t) || this;
    return c.onFinalize = u, c.shouldUnsubscribe = a, c._next = n ? function(h) {
      try {
        n(h);
      } catch (v) {
        t.error(v);
      }
    } : r.prototype._next, c._error = i ? function(h) {
      try {
        i(h);
      } catch (v) {
        t.error(v);
      } finally {
        this.unsubscribe();
      }
    } : r.prototype._error, c._complete = o ? function() {
      try {
        o();
      } catch (h) {
        t.error(h);
      } finally {
        this.unsubscribe();
      }
    } : r.prototype._complete, c;
  }
  return e.prototype.unsubscribe = function() {
    var t;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var n = this.closed;
      r.prototype.unsubscribe.call(this), !n && ((t = this.onFinalize) === null || t === void 0 || t.call(this));
    }
  }, e;
}(k), B = function(r) {
  return r && typeof r.length == "number" && typeof r != "function";
};
function $(r) {
  return s(r == null ? void 0 : r.then);
}
function q(r) {
  return s(r[R]);
}
function C(r) {
  return Symbol.asyncIterator && s(r == null ? void 0 : r[Symbol.asyncIterator]);
}
function J(r) {
  return new TypeError("You provided " + (r !== null && typeof r == "object" ? "an invalid object" : "'" + r + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function br() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var K = br();
function Q(r) {
  return s(r == null ? void 0 : r[K]);
}
function W(r) {
  return tr(this, arguments, function() {
    var t, n, o, i;
    return M(this, function(u) {
      switch (u.label) {
        case 0:
          t = r.getReader(), u.label = 1;
        case 1:
          u.trys.push([1, , 9, 10]), u.label = 2;
        case 2:
          return [4, E(t.read())];
        case 3:
          return n = u.sent(), o = n.value, i = n.done, i ? [4, E(void 0)] : [3, 5];
        case 4:
          return [2, u.sent()];
        case 5:
          return [4, E(o)];
        case 6:
          return [4, u.sent()];
        case 7:
          return u.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return t.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function X(r) {
  return s(r == null ? void 0 : r.getReader);
}
function x(r) {
  if (r instanceof l)
    return r;
  if (r != null) {
    if (q(r))
      return mr(r);
    if (B(r))
      return Sr(r);
    if ($(r))
      return wr(r);
    if (C(r))
      return Z(r);
    if (Q(r))
      return gr(r);
    if (X(r))
      return xr(r);
  }
  throw J(r);
}
function mr(r) {
  return new l(function(e) {
    var t = r[R]();
    if (s(t.subscribe))
      return t.subscribe(e);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function Sr(r) {
  return new l(function(e) {
    for (var t = 0; t < r.length && !e.closed; t++)
      e.next(r[t]);
    e.complete();
  });
}
function wr(r) {
  return new l(function(e) {
    r.then(function(t) {
      e.closed || (e.next(t), e.complete());
    }, function(t) {
      return e.error(t);
    }).then(null, j);
  });
}
function gr(r) {
  return new l(function(e) {
    var t, n;
    try {
      for (var o = I(r), i = o.next(); !i.done; i = o.next()) {
        var u = i.value;
        if (e.next(u), e.closed)
          return;
      }
    } catch (a) {
      t = { error: a };
    } finally {
      try {
        i && !i.done && (n = o.return) && n.call(o);
      } finally {
        if (t)
          throw t.error;
      }
    }
    e.complete();
  });
}
function Z(r) {
  return new l(function(e) {
    Er(r, e).catch(function(t) {
      return e.error(t);
    });
  });
}
function xr(r) {
  return Z(W(r));
}
function Er(r, e) {
  var t, n, o, i;
  return nr(this, void 0, void 0, function() {
    var u, a;
    return M(this, function(c) {
      switch (c.label) {
        case 0:
          c.trys.push([0, 5, 6, 11]), t = or(r), c.label = 1;
        case 1:
          return [4, t.next()];
        case 2:
          if (n = c.sent(), !!n.done)
            return [3, 4];
          if (u = n.value, e.next(u), e.closed)
            return [2];
          c.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = c.sent(), o = { error: a }, [3, 11];
        case 6:
          return c.trys.push([6, , 9, 10]), n && !n.done && (i = t.return) ? [4, i.call(t)] : [3, 8];
        case 7:
          c.sent(), c.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (o)
            throw o.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return e.complete(), [2];
      }
    });
  });
}
function d(r, e, t, n, o) {
  n === void 0 && (n = 0), o === void 0 && (o = !1);
  var i = e.schedule(function() {
    t(), o ? r.add(this.schedule(null, n)) : this.unsubscribe();
  }, n);
  if (r.add(i), !o)
    return i;
}
function z(r, e) {
  return e === void 0 && (e = 0), y(function(t, n) {
    t.subscribe(g(n, function(o) {
      return d(n, r, function() {
        return n.next(o);
      }, e);
    }, function() {
      return d(n, r, function() {
        return n.complete();
      }, e);
    }, function(o) {
      return d(n, r, function() {
        return n.error(o);
      }, e);
    }));
  });
}
function N(r, e) {
  return e === void 0 && (e = 0), y(function(t, n) {
    n.add(r.schedule(function() {
      return t.subscribe(n);
    }, e));
  });
}
function Ar(r, e) {
  return x(r).pipe(N(e), z(e));
}
function Pr(r, e) {
  return x(r).pipe(N(e), z(e));
}
function Ir(r, e) {
  return new l(function(t) {
    var n = 0;
    return e.schedule(function() {
      n === r.length ? t.complete() : (t.next(r[n++]), t.closed || this.schedule());
    });
  });
}
function Tr(r, e) {
  return new l(function(t) {
    var n;
    return d(t, e, function() {
      n = r[K](), d(t, e, function() {
        var o, i, u;
        try {
          o = n.next(), i = o.value, u = o.done;
        } catch (a) {
          t.error(a);
          return;
        }
        u ? t.complete() : t.next(i);
      }, 0, !0);
    }), function() {
      return s(n == null ? void 0 : n.return) && n.return();
    };
  });
}
function rr(r, e) {
  if (!r)
    throw new Error("Iterable cannot be null");
  return new l(function(t) {
    d(t, e, function() {
      var n = r[Symbol.asyncIterator]();
      d(t, e, function() {
        n.next().then(function(o) {
          o.done ? t.complete() : t.next(o.value);
        });
      }, 0, !0);
    });
  });
}
function Or(r, e) {
  return rr(W(r), e);
}
function _r(r, e) {
  if (r != null) {
    if (q(r))
      return Ar(r, e);
    if (B(r))
      return Ir(r, e);
    if ($(r))
      return Pr(r, e);
    if (C(r))
      return rr(r, e);
    if (Q(r))
      return Tr(r, e);
    if (X(r))
      return Or(r, e);
  }
  throw J(r);
}
function Rr(r, e) {
  return e ? _r(r, e) : x(r);
}
function Lr(r, e) {
  return y(function(t, n) {
    var o = 0;
    t.subscribe(g(n, function(i) {
      n.next(r.call(e, i, o++));
    }));
  });
}
function Fr(r, e) {
  return y(function(t, n) {
    var o = 0;
    t.subscribe(g(n, function(i) {
      return r.call(e, i, o++) && n.next(i);
    }));
  });
}
function Ur(r) {
  return y(function(e, t) {
    var n = null, o = !1, i;
    n = e.subscribe(g(t, void 0, void 0, function(u) {
      i = x(r(u, Ur(r)(e))), n ? (n.unsubscribe(), n = null, i.subscribe(t)) : o = !0;
    })), o && (n.unsubscribe(), n = null, i.subscribe(t));
  });
}
export {
  l as O,
  Fr as a,
  Ur as c,
  Rr as f,
  Lr as m
};
